import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=3d40ae2b&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40ae2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3d40ae2b', component.options)
    } else {
      api.reload('3d40ae2b', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=3d40ae2b&scoped=true&", function () {
      api.rerender('3d40ae2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/dashboard/dashboard.vue"
export default component.exports